<div id="customerDetailUserEditorId">
    <mat-card-header>
        <div class="auto-margin search-section">
            <mat-form-field class="full-width edit-cus-users-search-hint">
                <mat-icon matPrefix class="search-icon">search</mat-icon>
                <input
                    matInput
                    type="text"
                    placeholder="{{ 'COMMON.SEARCH_TEXT' | translate }}"
                    [formControl]="searchString"
                />
            </mat-form-field>
        </div>
        <div class="app-flex-filler"></div>
        <div class="auto-margin pad-r-25">
            <span class="textIntial">{{ 'COMMON.VIEW_ASSIGNED' | translate }}</span>
            <mat-slide-toggle
                [checked]="viewAssigned"
                [(ngModel)]="viewAssigned"
                (ngModelChange)="onChangeviewAssigned()"
                class="pad-l-10 edit-cus-users-assigned-hint"
            ></mat-slide-toggle>
        </div>
    </mat-card-header>
    <mat-card-content>
        <app-loader [isLoading]="isLoading"></app-loader>
        <div id="customersPageTable" [hidden]="!isMatTableVisible">
            <mat-table #table [dataSource]="userDataSource" matSort (matSortChange)="onDataSort()">
                <ng-container matColumnDef="isSelected">
                    <mat-header-cell *matHeaderCellDef class="fixCellWidth30">
                        <mat-checkbox
                            class="edit-cus-users-check-hint"
                            [checked]="isAllSelected"
                            (change)="toggleAllDisplayedUsersSelection($event)"
                        ></mat-checkbox>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                        <mat-checkbox
                            [checked]="element.isSelected"
                            [disabled]="!element.isActive"
                            (change)="toggleUserSelection(element, $event)"
                        ></mat-checkbox>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="username">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="edit-cus-users-username-hint">{{
                        'CUSTOMER_EDITOR.ASSIGN_USERS.USER_NAME' | translate
                    }}</mat-header-cell>
                    <mat-cell *matCellDef="let element">{{ element.username }} </mat-cell>
                </ng-container>
                <ng-container matColumnDef="userEmail">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="edit-cus-users-email-hint">{{
                        'CUSTOMER_EDITOR.ASSIGN_USERS.USER_EMAIL' | translate
                    }}</mat-header-cell>
                    <mat-cell *matCellDef="let element">{{ element.userEmail }} </mat-cell>
                </ng-container>
                <ng-container matColumnDef="name">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="edit-cus-users-name-hint">{{
                        'CUSTOMER_EDITOR.ASSIGN_USERS.NAME' | translate
                    }}</mat-header-cell>
                    <mat-cell *matCellDef="let element">{{ element.name }} </mat-cell>
                </ng-container>
                <ng-container matColumnDef="role">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="edit-cus-users-role-hint">{{
                        'CUSTOMER_EDITOR.ASSIGN_USERS.ROLE' | translate
                    }}</mat-header-cell>
                    <mat-cell *matCellDef="let element">{{ element.role }} </mat-cell>
                </ng-container>
                <ng-container matColumnDef="lastLogin">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="edit-cus-users-login-hint">{{
                        'CUSTOMER_EDITOR.ASSIGN_USERS.LAST_LOGIN' | translate
                    }}</mat-header-cell>
                    <mat-cell *matCellDef="let element">{{ element.lastLogin | date: dateFormat:timeZone }} </mat-cell>
                </ng-container>
                <ng-container matColumnDef="features">
                    <mat-header-cell *matHeaderCellDef class="edit-cus-users-feats-hint">{{
                        'CUSTOMER_EDITOR.ASSIGN_USERS.ASSIGNED_FEATURES' | translate
                    }}</mat-header-cell>
                    <mat-cell *matCellDef="let element" class="assign-user-feature-cell">
                        <ng-container *ngFor="let eachFeature of element.features; trackBy: trackByIndex">
                            <span>{{ eachFeature }}</span> <span class="comma-space">, </span>
                        </ng-container>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="isActive">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="edit-cus-users-status-hint">{{
                        'CUSTOMER_EDITOR.ASSIGN_USERS.ACTIVE_INACTIVE' | translate
                    }}</mat-header-cell>
                    <mat-cell *matCellDef="let element"
                        >{{ (element.isActive ? 'COMMON.YES_TEXT' : 'COMMON.NO_TEXT') | translate }}
                    </mat-cell>
                </ng-container>
                <div class="loc">
                    <ng-container matColumnDef="editLoc">
                        <mat-header-cell *matHeaderCellDef></mat-header-cell>
                        <mat-cell *matCellDef="let element" class="text-right">
                            <mat-icon class="edit-cus-users-edit-hint" (click)="locationAssociation(element)">mode_edit</mat-icon>
                        </mat-cell>
                    </ng-container>
                </div>
                <mat-header-row *matHeaderRowDef="customerDtlUserEdtrColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: customerDtlUserEdtrColumns"></mat-row>
            </mat-table>
        </div>
        <div class="notabledataFound custom-table" *ngIf="!isMatTableVisible">
            {{ 'ADMIN.NO_DATA_AVAILABLE' | translate }}
        </div>
    </mat-card-content>
    <mat-paginator
        hidden
        [length]="totalPaginationLength"
        [pageIndex]="0"
        [pageSize]="25"
    ></mat-paginator>
</div>
